import { Button, Col, Row } from "antd";
import React, { useState } from "react";
import ModalComponent from "../../components/UI/Modal/Modal";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import { SignatureComponent } from "./SignatureComponent";
import axiosInstance from "../../api/utils/axiosInstance";
import { toast } from "react-toastify";
import Axios from "axios";

export const SignatureModal = ({ show, onCancel, onHide, zahtjevAtrId, dataType, onFinished }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [showSignature, setShowSignature] = useState(false);

	const openSignature = async () => {
		//for now we disable check because cors is acting up when trying to get on localhost not sure if it's a browser problem or not
		//anyway, maybe we won't even check at all, if signature failes to start that means user hasn't installed the FinaPKI.exe which is describe in the user manual
		const isRunning = await checkLocalhostAppRunning();
		
		if(isRunning){
			setShowSignature(true);
		}
	};

	const hideSignature = () => {
		setShowSignature(false);
	};

	const handleCancel = () => {
		hideSignature();
		onCancel();
	}

	const handleFinish = () => {
		hideSignature();
		onFinished();
	}

	const checkLocalhostAppRunning = async () =>{
		setIsLoading(true);
		const instance = Axios.create({
			baseURL: 'http://localhost:8897',
			//timeout: 2000,
		});

		try{
			const res = await instance.get('/api/Application/echo', {headers:{
				"Access-Control-Allow-Origin": "*"
			}});
			if(res && res.status === 200){
				setIsLoading(false);
				return true;
			}
		}catch(e){
			let toastMsg = "PKI modul nije pokrenut, preuzmite novu verziju PKI modula";
			toast.error(toastMsg, {position: toast.POSITION.BOTTOM_RIGHT});
			setIsLoading(false);
			return false;
		}

	}

	const getFinaPkiUputa = async () => {
		setIsLoading(true);
		try {
		  const res = await axiosInstance.get("/signature/v2/fina-pki-uputa", {
			method: "get",
			responseType: "blob",
		  });
		  const file = new Blob([res.data], {
			type: "application/pdf",
		  });
		  let a = document.createElement("a");
		  document.body.appendChild(a);
		  let fileUrl = URL.createObjectURL(file);
		  a.href = fileUrl;
		  a.download = "pkiUputa.pdf";
		  a.click();
		} catch (error) {
		  throw error;
		}finally{
			setIsLoading(false);
		}
	  };

	return (
		<>
			<ModalComponent show={show} onHide={onHide} title={"Želite li potpisati zahtjev?"} backdrop="static" keyboard={false}>
				<Row justify={"center"}>
					<p>NAPOMENA: Za potpis je potrebno preuzeti i instalirati PKI modul.</p>
					<p>Korisničku uputu za pripremu računala za rad s Fininim potpisnim modulom možete preuzeti ovdje:</p>
					<div>
						<Button icon={<FilePdfOutlined />} type="link" onClick={getFinaPkiUputa}>
							Preuzmi uputu
						</Button>
					 	<Button icon={<DownloadOutlined />} type="link" href="https://cdn.fina.hr/finapki/FinaPotpis_x64.exe">
							Preuzmi PKI modul
						</Button>
					</div>
				</Row>
				<Row justify={"space-evenly"}>
					<Col>
						<Button block type="primary" onClick={openSignature} loading={isLoading}>
							Da
						</Button>
					</Col>
					<Col>
						<Button block type="danger" onClick={handleCancel}>
							Ne
						</Button>
					</Col>
				</Row>
			</ModalComponent>

			<ModalComponent show={showSignature} title={"Potpisivanje"} onHide={hideSignature} backdrop="static" keyboard={false}>
				<SignatureComponent zahtjevAtrId={zahtjevAtrId} handleCancel={handleCancel} dataType={dataType} handleFinished={handleFinish}/>
			</ModalComponent>
		</>
	);
};
